import React, { useMemo } from 'react';
import { SimpleKPIChart } from './simple-kpi-chart';
import { SparklineKPIChart } from './sparkline-kpi-chart';
import { shouldShowSparkline } from './utils';
export const KPIChartV2 = React.memo(React.forwardRef((props, ref) => {
    const { chartModel } = props;
    const showSparkline = useMemo(() => shouldShowSparkline(chartModel), [chartModel]);
    if (showSparkline) {
        return React.createElement(SparklineKPIChart, { ...props, ref: ref });
    }
    return React.createElement(SimpleKPIChart, { ...props, ref: ref });
}));
//# sourceMappingURL=kpi-chart-v2.js.map